import styled, { css } from 'styled-components';

export const Welcome = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
  `}
`;
